import currentUser from '@rover/globals/currentUser';
import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import { submitLogoutForm } from '@rover/rsdk/src/modules/Network/submitLogoutForm';

import { localStorage, sessionStorage } from './storage';

const logout = (ref: string): void => {
  localStorage.clear();
  sessionStorage.clear();
  currentUser.authenticated = false;
  submitLogoutForm(undefined, ref);
};

function showAnonymousElements(): void {
  $('.js-anonymous-user').removeClass('hide');
}

function init(): void {
  currentUser
    .waitForAnonymousUserLoaded()
    .then(() => showAnonymousElements())
    .catch(() => {});
}

Rover.utils = Rover.utils || {};
Rover.utils.logout = logout;
const exportedAuth = {
  init,
  showAnonymousElements,
  logout,
};
export default exportedAuth;
